export default __webpack_public_path__ + "static/media/archive.f124faeb.svg";